export default function addressData() {
    function initializeBinRegistration(){
        initAutocomplete();
    }


    let autocomplete;
    let componentForm = {
        locality: 'long_name',
        postal_code: 'short_name',
        administrative_area_level_1: 'long_name'
    };

    function initAutocomplete() {
        var input = document.getElementById('SearchAddress');
        var options = {
            componentRestrictions: {country: "nz"}
        };
        autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'], options });

        autocomplete.addListener('place_changed', fillInAddress);
    }

    function fillInAddress() {
        var region = '';
        var city = '';
        var suburb = '';
        var postcode = '';

        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();

        document.getElementsByClassName('customerAddress')[0].value = '';
        document.getElementsByClassName('locality')[0].value = '';
        document.getElementsByClassName('postal_code')[0].value = '';
        document.getElementsByClassName('city')[0].value = '';

        // Get each component of the address from the place details
        // and fill the corresponding field on the form.
        for (var i = 0; i < place.address_components.length; i++) {
            var addressType = place.address_components[i].types[0];

            if (componentForm[addressType]) {
                var val = place.address_components[i][componentForm[addressType]];
                if(addressType === 'locality'){
                    city = val;
                    suburb = place.vicinity;
                }
                if(addressType === 'postal_code'){
                    postcode = val;
                }
                if(addressType === 'administrative_area_level_1'){
                    region = val;
                }

            }
        }
        if(region.toLowerCase().includes("otago")){
            document.getElementsByClassName('customerAddress')[0].value = customerAddress;
            document.getElementsByClassName('locality')[0].value = suburb;
            document.getElementsByClassName('postal_code')[0].value = postcode;
            document.getElementsByClassName('city')[0].value = city;
        }
    }

    $(document).ready(function() {
        if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            initAutocomplete();
        } else {
            setTimeout(function() {
                initializeBinRegistration();
            }, 2000);
        }

        $(window).keydown(function(event){
            if(event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        });
    });
}
